import * as pedido from '@/api/pedido'
import * as listagem from '@/api/listagem'

import { permiteAction } from '@/service/acao'

import { clone } from '@/service/util'

import * as storeAuth from '../auth'

const date = new Date()

function right (string, posicoes) {
  return string.slice(string.length - posicoes)
}

const state = {
  carregado: false,
  control: {
    tipo: false,
    lancamento: {
      oportunidades: { qtd: 0, total: 0.00 },
      filtros: {
        nome: null,
        data_inicial: new Date(date.getFullYear(), date.getMonth(), 1),
        data_final: new Date(date.getFullYear(), date.getMonth() + 1, 0)
      },
      a_lancar: [],
      lancados: [],
      rentabilidade_total: 0,
      comissao_total: 0,
      valor_total: 0
    },
    fechamento: {
      oportunidades: { qtd: 0, total: 0.00 },
      filtros: {
        dataIni: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
        dataFim: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 20),
        nome: null
      },
      list: [],
      outros: [],
      rentabilidade_total: 0,
      comissao_total: 0,
      valor_total: 0
    },
    quente: {
      oportunidades: { qtd: 0, total: 0.00 },
      filtros: {
        dataIni: new Date(),
        dataFim: new Date(),
        nome: null
      },
      list: [],
      outros: [],
      rentabilidade_total: 0,
      comissao_total: 0,
      valor_total: 0,
      dadosUsuario: {
        rentabilidade_total: 0,
        comissao_total: 0,
        valor_total: 0
      }
    },
    morno: {
      oportunidades: { qtd: 0, total: 0.00 },
      filtros: {
        dataIni: new Date(),
        dataFim: new Date(),
        nome: null
      },
      list: [],
      outros: [],
      rentabilidade_total: 0,
      comissao_total: 0,
      valor_total: 0,
      dadosUsuario: {
        rentabilidade_total: 0,
        comissao_total: 0,
        valor_total: 0
      }
    },
    frio: {
      oportunidades: { qtd: 0, total: 0.00 },
      filtros: {
        dataIni: new Date(),
        dataFim: new Date(),
        nome: null
      },
      list: [],
      outros: [],
      rentabilidade_total: 0,
      comissao_total: 0,
      valor_total: 0,
      dadosUsuario: {
        rentabilidade_total: 0,
        comissao_total: 0,
        valor_total: 0
      }
    },
    novo: {
      oportunidades: { qtd: 0, total: 0.00 },
      filtros: {
        nome: null
      },
      novos: [],
      agendados: []
    },
    leads: {
      oportunidades: { qtd: 0, total: 0.00 },
      filtros: {
        nome: null
      },
      leads: [],
      agendados: []
    },
    tlmk: {
      filtros: {
        label: null,
        value: null
      },
      novos: [],
      agendados: []
    },
    consulta: {
      oportunidades: { qtd: 0, total: 0.00 },
      filtros: {
        label: null,
        value: null
      },
      list: []
    }
  }
}

const getters = {
  oportunidades: state => {
    return {
      lancamento: state.control.lancamento.oportunidades,
      fechamento: state.control.fechamento.oportunidades,
      quente: state.control.quente.oportunidades,
      morno: state.control.morno.oportunidades,
      frio: state.control.frio.oportunidades,
      novo: state.control.novo.oportunidades,
      leads: state.control.leads.oportunidades,
      tlmk: {},
      consulta: {}
    }
  }
}

const mutations = {
  SETCARREGADO (state) {
    state.carregado = true
  },
  SETOPORTUNIDADEAGENDADO (state, payload) {
    state.control.fechamento.oportunidades = payload.fechamento
    state.control.quente.oportunidades = payload.quente
    state.control.morno.oportunidades = payload.morno
    state.control.frio.oportunidades = payload.frio
  },
  SETOPORTUNIDADENOVO (state, payload) {
    state.control.novo.oportunidades = payload
  },
  SETTIPO (state, payload) {
    state.control.tipo = payload
  },
  REMOVETIPO (state) {
    state.control.tipo = false
  },
  SETTIPOFILTRO (state, { tipo, filtros }) {
    state.control[tipo].filtros = filtros
  },
  SETTIPOLIST (state, { tipo, retorno }) {
    if (retorno) {
      if (tipo === 'novo' || tipo === 'tlmk') {
        if (retorno) {
          if (tipo === 'tlmk') {
            state.control[tipo].novos = retorno.novos
            state.control[tipo].agendados = retorno.agendados
          } else {
            state.control[tipo].novos = retorno.novos
            state.control[tipo].agendados = retorno.agendados
          }
        }
      } else if (tipo === 'lancamento') {
        state.control[tipo].a_lancar = retorno.a_lancar
        state.control[tipo].lancados = retorno.lancados
      } else if (tipo === 'leads') {
        state.control[tipo].agendados = retorno.instancia.agendados
        state.control[tipo].leads = retorno.instancia.leads
      } else {
        state.control[tipo].list = retorno.list
        if (retorno.outros) state.control[tipo].outros = retorno.outros
        state.control[tipo].dadosUsuario = retorno.dadosUsuario
      }
      if (tipo !== 'novo' || tipo !== 'tlmk') {
        state.control[tipo].valor_total = retorno.valor_total
        state.control[tipo].comissao_total = retorno.comissao_total
        state.control[tipo].rentabilidade_total = retorno.rentabilidade_total
      }
    }
  },
  SETTIPOLISTOUTRO (state, { tipo, retorno }) {
    if (retorno) {
      state.control[tipo].outros = retorno.list
    }
  },
  SETTIPOOPORTUNIDADE (state, { tipo, oportunidades }) {
    if (tipo === 'leads') state.control[tipo].oportunidades = oportunidades.instancia
    else state.control[tipo].oportunidades = oportunidades
  },
  SETTIPOOPORTUNIDADELEADNOVO (state, oportunidades) {
    state.control.leads.leads = [oportunidades]
  },
  SETTOTALIZADORESLISTA (state, { dadosAtualizados, tipo }) {
    state.control[tipo].valor_total = dadosAtualizados.valor_total
    state.control[tipo].comissao_total = dadosAtualizados.comissao_total
    state.control[tipo].rentabilidade_total = dadosAtualizados.rentabilidade_total
  }
}

const actions = {
  async load ({ state, dispatch, commit }) {
    let grupo = await dispatch('auth/getGrupoComp', null, { root: true })
    if (grupo === 'promotorLoja' && !state.carregado) {
      let agendado = await pedido.getOportunidades()
      if (permiteAction('visualizar_novo')) {
        let novo = await pedido.getOportunidadesNovos()
        commit('SETOPORTUNIDADENOVO', novo)
      }
      if (permiteAction('atender_cliente')) {
        let oportunidades = await pedido.getOportunidadesLanca()
        commit('SETTIPOOPORTUNIDADE', { oportunidades, tipo: 'lancamento' })
      }
      if (agendado) commit('SETOPORTUNIDADEAGENDADO', agendado)

      if (storeAuth.default.state.usuario.unidade.ver_leads_simulador) {
        let oportunidades = await pedido.getOportunidadesLeads()
        commit('SETTIPOOPORTUNIDADE', { oportunidades, tipo: 'leads' })
      }

      commit('SETCARREGADO')
    }
  },
  openCloseTipo ({ state, commit }, tipo) {
    if (state.control.tipo === tipo) return commit('REMOVETIPO')
    return commit('SETTIPO', tipo)
  },
  openQuente ({ commit }) {
    return commit('SETTIPO', 'quente')
  },
  async filtraAgendado ({ commit }, { filtros, tipo }) {
    const data = { classificacao: tipo, ...filtros }
    const retorno = await pedido.listAgendadosTipo(data)
    commit('SETTIPOFILTRO', { filtros, tipo })
    commit('SETTIPOLIST', { retorno, tipo })
    filtros.classificacao = tipo
  },
  async filtraAgendadoOutros ({ commit, dispatch }, { filtros, tipo }) {
    const data = { classificacao: tipo, ...filtros }
    const retorno = await pedido.listAgendadosOutroTipo(data)
    commit('SETTIPOLISTOUTRO', { retorno, tipo })
    return dispatch('atualizaTotalizadores', { tipo, retorno })
  },
  atualizaTotalizadores ({ commit }, dados) {
    let dadosUsuario = clone(state.control[dados.tipo].dadosUsuario)
    let dadosAtualizados = {
      valor_total: dadosUsuario.valor_total + dados.retorno.valor_total,
      comissao_total: dadosUsuario.comissao_total + dados.retorno.comissao_total
    }
    dadosAtualizados.rentabilidade_total = dadosAtualizados.comissao_total !== 0 ? parseFloat(((dadosAtualizados.comissao_total * 100) / dadosAtualizados.valor_total).toFixed(2)) : 0

    commit('SETTOTALIZADORESLISTA', { dadosAtualizados, tipo: dados.tipo })
  },
  async filtraLanca ({ commit }, filtros) {
    let dataInicial = filtros.data_inicial
    let dataFinal = filtros.data_final
    let param = clone(filtros)
    param.data_inicial = dataInicial // dataInicial.getFullYear() + '-' + (dataInicial.getMonth() + 1) + '-' + dataInicial.getDay()
    param.data_final = dataFinal // dataFinal.getFullYear() + '-' + (dataFinal.getMonth() + 1) + '-' + dataFinal.getDay()
    const retorno = await pedido.listPedidosLanca(param)
    const oportunidades = await pedido.getOportunidadesLanca(param)
    commit('SETTIPOFILTRO', { filtros, tipo: 'lancamento' })
    commit('SETTIPOLIST', { retorno, tipo: 'lancamento' })
    commit('SETTIPOOPORTUNIDADE', { oportunidades, tipo: 'lancamento' })
  },
  async filtraFechamento ({ dispatch }, filtros) {
    return dispatch('filtraAgendado', { tipo: 'fechamento', filtros })
  },
  async filtraQuente ({ dispatch }, filtros) {
    return dispatch('filtraAgendado', { tipo: 'quente', filtros })
  },
  async buscaOutroTodosQuente ({ dispatch }, filtros) {
    return dispatch('filtraAgendadoOutros', { tipo: 'quente', filtros })
  },
  async filtraMorno ({ dispatch }, filtros) {
    return dispatch('filtraAgendado', { tipo: 'morno', filtros })
  },
  async buscaOutroTodosMorno ({ dispatch }, filtros) {
    return dispatch('filtraAgendadoOutros', { tipo: 'morno', filtros })
  },
  async filtraFrio ({ dispatch }, filtros) {
    return dispatch('filtraAgendado', { tipo: 'frio', filtros })
  },
  async buscaOutroTodosFrio ({ dispatch }, filtros) {
    return dispatch('filtraAgendadoOutros', { tipo: 'frio', filtros })
  },
  async filtraConsulta ({ dispatch }, filtros) {
    return dispatch('filtraAgendado', { tipo: 'consulta', filtros })
  },
  async filtraNovo ({ commit }, filtros) {
    const retorno = await pedido.listPedidosNovos(filtros)
    const oportunidades = await pedido.getOportunidadesNovos(filtros)
    commit('SETTIPOFILTRO', { filtros, tipo: 'novo' })
    commit('SETTIPOLIST', { retorno, tipo: 'novo' })
    commit('SETTIPOOPORTUNIDADE', { oportunidades, tipo: 'novo' })
  },
  async filtraTlmk ({ commit }, filtros) {
    if (filtros) {
      const retorno = await listagem.usuarioItens(filtros.value)
      commit('SETTIPOFILTRO', { filtros, tipo: 'tlmk' })
      commit('SETTIPOLIST', { retorno, tipo: 'tlmk' })
    } else {
      filtros = {
        value: '',
        label: ''
      }
    }
    commit('SETTIPOFILTRO', { filtros, tipo: 'tlmk' })
  },
  async filtraLeads ({ commit }, filtros) {
    const retorno = await pedido.listLeads(filtros)
    const oportunidades = await pedido.getOportunidadesLeads(filtros)
    commit('SETTIPOFILTRO', { filtros, tipo: 'leads' })
    commit('SETTIPOLIST', { retorno, tipo: 'leads' })
    commit('SETTIPOOPORTUNIDADE', { oportunidades, tipo: 'leads' })
  },
  async getLeadNovo ({ commit }) {
    const retorno = await pedido.getOportunidadeLead()
    if (retorno.instancia) {
      if (retorno.instancia.id) commit('SETTIPOOPORTUNIDADELEADNOVO', retorno.instancia)
    }
    return retorno.instancia
  },
  async atualizaOportunidades ({ state, commit }, dados) {
    if (dados) {
      if (dados.tipo) {
        if (dados.tipo === 'lanca') {
          let oportunidades = await pedido.getOportunidadesLanca(dados)
          commit('SETTIPOOPORTUNIDADE', { oportunidades, tipo: 'lancamento' })
        } else if (dados.tipo === 'novo') {
          let oportunidades = await pedido.getOportunidadesNovos(dados)
          commit('SETTIPOOPORTUNIDADE', { oportunidades, tipo: 'novo' })
        }
      } else if (dados.classificacao) {
        if (dados.classificacao === 'fechamento') {
          let dataAtual = new Date()
          let dataInicial = dataAtual.getFullYear() + '-' + right('0' + (dataAtual.getMonth() + 1), 2) + '-' + right('0' + dataAtual.getDate(), 2) + 'T03:00:00.000Z'
          let dataMais20 = new Date()
          dataMais20.setDate(dataAtual.getDate() + 20)
          let dataFinal = dataMais20.getFullYear() + '-' + right('0' + (dataMais20.getMonth() + 1), 2) + '-' + right('0' + dataMais20.getDate(), 2) + 'T03:00:00.000Z'
          dados.dataIni = dataInicial
          dados.dataFim = dataFinal
        }
        let oportunidades = await pedido.getOportunidadesTipo(dados)
        let tipo = dados.classificacao
        commit('SETTIPOOPORTUNIDADE', { oportunidades: oportunidades[tipo], tipo })
      }
    } else {
      let oportunidades = await pedido.getOportunidades()
      commit('SETOPORTUNIDADEAGENDADO', oportunidades)
    }
  },
  async atualizaLista ({ state, commit, dispatch }, dados) {
    if (dados.tipo === 'lancamento') {
      let retorno = await pedido.listPedidosLanca(dados)
      commit('SETTIPOLIST', { retorno, tipo: 'lancamento' })
    } else if (dados.tipo === 'novo') {
      let retorno = await pedido.listPedidosNovos(dados)
      commit('SETTIPOLIST', { retorno, tipo: 'novo' })
    } else if (dados.tipo === 'tlmk') {
      if (state.control.tlmk.filtros.value) {
        let retorno = await listagem.usuarioItens(state.control.tlmk.filtros.value)
        commit('SETTIPOLIST', { retorno, tipo: 'tlmk' })
      }
    } else if (dados.tipo === 'leads') {
      dispatch('filtraLeads', state.control[dados.tipo].filtros)
    } else if (dados.tipo) {
      let retorno = await pedido.listAgendadosTipo({classificacao: dados.tipo})
      let tipo = dados.tipo
      commit('SETTIPOLIST', { retorno, tipo })
    }
  }
}

export default { namespaced: true, state, getters, mutations, actions }



// WEBPACK FOOTER //
// ./src/store/modules/pedido/painelPromotor.js